import EntryTable from '@/pages/mypage/entryTable';
import NewsTable from '@/pages/mypage/newsTable';
import MemberMenu from '@/pages/mypage/memberMenu';
import SessionGuard from '@/pages/SessionGuard';

const MyPage = () => {

  return (
    <>
     <SessionGuard redirectTo="/login">
      <div><EntryTable /></div>
      <div className="mt-[1.6rem] xmd:mt-[6.4rem]"><NewsTable /></div>
      <div className="mt-[1.6rem] xmd:mt-[3.2rem]"><MemberMenu /></div>
      </SessionGuard>
    </>
  );
};

export default MyPage;
